import techsByCategory from './techsByCategory';
import policiesRaw from './policies.json';

const hash = require('object-hash');

// Generate a hash of tech categories for easier lookup
const categoriesByTech = Object.keys(techsByCategory).reduce(
  (categoriesByTech, category) => {
    techsByCategory[category].forEach((tech) => {
      categoriesByTech[tech] = category;
    });
    return categoriesByTech;
  },
  {}
);

export const policies = policiesRaw
  .filter(
    (policy) =>
      policy.startYear && policy.tech && policy.budgetUSD && !policy.private
  )
  .reduce((uniquePolicies, policy) => {
    const dupe = uniquePolicies.findIndex(
      (dupePolicy) =>
        dupePolicy.id === policy.id &&
        dupePolicy.tech === policy.tech &&
        dupePolicy.startYear === policy.startYear &&
        dupePolicy.fundingType === policy.fundingType
    );
    if (dupe > -1) {
      uniquePolicies[dupe].budgetUSD += policy.budgetUSD;
      return uniquePolicies;
    }
    return [...uniquePolicies, policy];
  }, [])
  .map((policy, index) => ({
    ...policy,
    budgetUSD: policy.fundingType === 'Government' ? policy.budgetUSD : 0,
    otherBudget: policy.fundingType !== 'Government' ? policy.budgetUSD : 0,
    category: categoriesByTech[policy.tech],
    categories: [],
    key: hash({ ...policy, index }),
  }));

export const policyGroups = policies.reduce((grouped, policy) => {
  // see if this policy already exists
  const existing = grouped.find((p) => policy.id === p.id);
  if (existing) {
    if (existing.startYear > policy.startYear)
      existing.startYear = policy.startYear;
    if (existing.endYear < policy.endYear) existing.endYear = policy.endYear;
    if (existing.tech !== policy.tech) existing.tech = 'Multiple';
    if (!existing.categories.includes(policy.category))
      existing.categories.push(policy.category);
    if (existing.categories.length > 1) existing.category = 'Multiple';
    existing.budgetUSD += policy.budgetUSD;
    existing.otherBudget += policy.otherBudget;
    existing.policies.push(policy);
  } else {
    const newPolicyGroup = {
      index: grouped.length,
      id: policy.id,
      title: policy.title,
      country: policy.country,
      region: policy.region,
      tech: policy.tech,
      categories: [policy.category],
      category: policy.category,
      status: policy.status,
      jurisdiction: policy.jurisdiction,
      startYear: policy.startYear,
      endYear: policy.endYear,
      budgetUSD: policy.budgetUSD,
      otherBudget: policy.otherBudget,
      parentIDs: policy.parentIDs,
      parentTitles: policy.parentTitles,
      policies: [policy],
      open: false,
      isGroup: true,
    };
    newPolicyGroup.key = hash(newPolicyGroup);
    grouped.push(newPolicyGroup);
  }
  return grouped;
}, []);

if (
  policyGroups.filter((policy) => !policy.category).map((policy) => policy.tech)
    .length > 0
) {
  console.error(
    'Data error: invalid entries',
    policyGroups
      .filter((policy) => !policy.category)
      .map((policy) => policy.tech)
  );
}

export const totalByPolicyId = policies.reduce((totalByPolicy, policy) => {
  totalByPolicy[policy.id] = (totalByPolicy[policy.id] || 0) + policy.budgetUSD;
  return totalByPolicy;
}, {});

export const baseColumns = [
  { key: 'title', label: 'Policy', align: 'left', sortable: true },
  { key: 'tech', label: 'Measures', sortable: true, align: 'left' },
  { key: 'startYear', label: 'Start year', sortable: true, align: 'center' },
  { key: 'status', label: 'Status', sortable: true, align: 'left' },
  /* { key: 'endYear', label: 'End year', sortable: true, align: 'center' }, */
  {
    key: 'relevantBudget',
    label: 'Budget commitment (million USD)',
    align: 'center',
    sortable: true,
  },
];
export const emerging = [
  'Brazil',
  'Colombia',
  'India',
  'Indonesia',
  'Nigeria',
  'Russian Federation',
];
